import { useState } from 'react';

import { IconEdit } from '@xing-com/icons';

import { ARTICLES_ARTICLE_EDIT_LINK } from '../../../../constants/urls';
import { LinkShareModalPage } from '../../../link-share-modal-page/link-share-modal-page';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

type Props = Omit<ArticleControlButton, 'onLoadingChange' | 'onError'>;

export const ArticleEditButton: React.FC<Props> = ({ article, disabled }) => {
  const articleIdSlugged = article.id;
  const [showModal, setShowModal] = useState(false);
  const isContentArticle = article.typename === 'ContentArticle';

  const handleOnClick = () => {
    if (isContentArticle) {
      setShowModal(true);
    } else {
      const editUrl = ARTICLES_ARTICLE_EDIT_LINK(articleIdSlugged);
      window.location.assign(editUrl);
    }
  };

  return (
    <>
      <Styled.Button
        data-testid="ARTICLE-EDIT-BUTTON"
        icon={IconEdit}
        size="small"
        variant="tertiary"
        disabled={disabled}
        onClick={handleOnClick}
      />

      {isContentArticle ? (
        <LinkShareModalPage
          showModal={showModal}
          setShowModal={setShowModal}
          linkShareGlobalId={article.globalId}
        />
      ) : null}
    </>
  );
};
